import React from 'react';
import { BasicInput } from './wrappers/inputs/withFormProps';
import { TooltipProps, IconV2Props } from '@kizi/shared-components';
import { ModalWithAccordion, ModalWithAccordionProps } from './modals';

export interface EmailOptionalProps {
  privacyModal?: ModalWithAccordionProps;
  placeholder?: string;
  tooltip?: TooltipProps<IconV2Props>['_tooltip'];
}

export const EmailOptional: React.FC<EmailOptionalProps> = ({
  privacyModal,
  placeholder,
  tooltip = null,
  ...props
}: EmailOptionalProps) => {
  const footnote = privacyModal ? (
    <ModalWithAccordion
      buttonProps={{ mt: 1 }}
      variant="transparentSmall"
      {...privacyModal}
    />
  ) : null;

  return (
    <BasicInput
      {...props}
      type="email"
      inputMode="email"
      placeholder={placeholder}
      _tooltip={tooltip}
      _footnote={footnote}
    />
  );
};
